import styled from "@emotion/styled";
import { Box, CompassColor, Text } from "@noom/wax-component-library";
import React from "react";

import truckIcon from "../../image_assets/truck.svg";

const CalendarIcon = styled.img`
  width: 25px;
  height: 25px;
`;

const TruckIcon = styled.img`
  width: 30px;
  height: 35px;
  margin-top: 10px;
`;

const DottedLine = styled.div`
  position: absolute;
  left: 15px;
  top: 35px;
  width: 2px;
  height: 40px;
  background-image: repeating-linear-gradient(
    to bottom,
    ${CompassColor.sand02} 0px,
    ${CompassColor.sand02} 4px,
    transparent 4px,
    transparent 8px
  );
`;

export type UpcomingShipmentSectionProps = {
  title: string;
  titleDataCy: string;
  sectionDataCy: string;
  headerAction?: React.ReactNode;
  statusIconSrc: string;
  statusIconAlt: string;
  statusIconDataCy: string;
  statusLabel: string;
  statusLabelDataCy: string;
  statusLabelAccessory?: React.ReactNode;
  dateText: string;
  dateTextDataCy: string;
  deliveryWindow: string;
};

export const UpcomingShipmentSection: React.FC<
  UpcomingShipmentSectionProps
> = ({
  title,
  titleDataCy,
  sectionDataCy,
  headerAction,
  statusIconSrc,
  statusIconAlt,
  statusIconDataCy,
  statusLabel,
  statusLabelDataCy,
  statusLabelAccessory,
  dateText,
  dateTextDataCy,
  deliveryWindow,
}) => (
  <Box
    marginBottom="16px"
    width="100%"
    padding="24px"
    backgroundColor={CompassColor.white}
    borderRadius="8px"
    fontFamily="Untitled Sans, sans-serif"
    data-cy={sectionDataCy}
  >
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      marginBottom="20px"
    >
      <Text fontSize="18px" fontWeight="500" margin="0" data-cy={titleDataCy}>
        {title}
      </Text>
      {headerAction}
    </Box>

    <Box position="relative">
      <Box display="flex" alignItems="center">
        <Box
          width="32px"
          height="32px"
          marginRight="16px"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <CalendarIcon
            src={statusIconSrc}
            alt={statusIconAlt}
            data-cy={statusIconDataCy}
          />
        </Box>
        <Text
          display="flex"
          alignItems="center"
          fontSize="16px"
          color={CompassColor.black}
          data-cy={statusLabelDataCy}
        >
          {statusLabel}
          {statusLabelAccessory}
        </Text>
      </Box>
      <Text
        marginLeft="48px"
        fontSize="15px"
        color={CompassColor.black}
        fontWeight="400"
        data-cy={dateTextDataCy}
      >
        {dateText}
      </Text>

      <DottedLine />

      <Box
        display="flex"
        alignItems="center"
        marginTop="10px"
        data-cy="delivery-window-section"
      >
        <Box
          width="32px"
          height="32px"
          marginRight="16px"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <TruckIcon src={truckIcon} alt="Truck icon" data-cy="truck-icon" />
        </Box>
        <Text
          display="flex"
          alignItems="center"
          fontSize="16px"
          color={CompassColor.black}
          data-cy="delivery-window-label"
        >
          Estimated delivery window
        </Text>
      </Box>
      <Text
        marginLeft="48px"
        fontSize="15px"
        color={CompassColor.black}
        data-cy="delivery-window-dates"
      >
        {deliveryWindow}
      </Text>
    </Box>
  </Box>
);
